import { mapState as rootMapState, mapActions as rootMapActions } from 'pinia';
import { usePageStore } from '@/store';
import bannerMixins from '../../mixins/banner';
import banner from '../../components/banner.vue';
import { PrefetchMethod } from '@/config';

import agentShare from './standard/agent-share.vue';
import { normal } from '../defaultSpacing';
export default {
    mixins: [bannerMixins],
    i18next: {
        ns: 'md-banner'
    },
    data: function() {
        return {
            mode: '',
            agentId: 0,
            videoOption: {
                previewSrc: '',
                src: '',
                autoplay: true,
                playInline: false,
                showProgress: false,
                videoMuted: false,
                showMuteButton: true,
                autoHeight: false,
                hidePlayButton: true
            },
            bannerStyle: {},
            contentStyle: {},
            title: '',
            subTitle: '',
            showLine: false,
            contentFull: false,
            linePos: 'top',
            lineStyle: {},
            ...normal
        };
    },
    [PrefetchMethod]() {
        return this.getAgentInfo(this.agentId);
    },
    computed: {
        ...rootMapState(usePageStore, {
            "page": store => store.page || {},
            "agents": store => store.agents
        }),
        agent() {
            let res = this.agents[this.agentId] || {};
            let socialNetworks = res.agentSocialNetworks;
            let fullName = res.firstName + ' ' + res.lastName;
            return Object.assign(res, {
                socialNetworks,
                fullName
            });
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        useType() {
            return this.type;
        }
    },
    methods: {
        ...rootMapActions(usePageStore, {
            "getAgentInfo": "getAgentInfo"
        }),
        doVideoPlay() {
            this.$refs.banner && this.$refs.banner.doVideoPlay();
        }
    },
    components: {
        banner,
        agentShare
    }
};
